import { useState } from "react"
import styled from "styled-components"
import Faq from "../../models/Faq.model"

type FaqProps = {
  faq: Faq
}


export default function FaqItem(props:FaqProps) {
  const [showAnswer, setShowAnswer] = useState(false)

  return (
    <FaqItemContainer className={`faq_item ${showAnswer ? 'open' : ''}`}
      onClick={e => setShowAnswer(!showAnswer)}
    >
      <div className="area_q flex">
        <p className="green">Q</p>
        <strong className="flex1">{props.faq.title}</strong>
        <img src="/images/arrow_down.png" alt="arrow_down" />
      </div>

      {showAnswer && (
        <pre className="area_a">{props.faq.description}</pre>
      )}
    </FaqItemContainer>
  )
}

const FaqItemContainer = styled.li`
  cursor: pointer;
  position: relative;

  &.open{
    background-color: #fafafa;
    .area_q img{
      transform: rotate(180deg);
    }
  }

  .area{
    &_q{
      p.green{
        font-family: 'Montserrat';
        line-height: 26px;
      }
      strong{
        padding: 0 10px;
        line-height: 26px;
      }
      img{
        width: 12px;
        height: 26px;
        padding: 7px 0;
        transition: all .25s;
      }
    }

    &_a{
      color: #808080;
      line-height: 1.5;
      white-space: pre-wrap;
    }
  }

  &:not(.open) + .faq_item:not(.open)::before{
    content: '';
    width: calc(100% - 40px);
    height: 1px;
    background-color: #f2f2f2;
    position: absolute;
    top: 0;
    left: 20px;
  }

  @media screen and (min-width: 501px) {
    padding: 26px 20px 21px;
    &:hover{
      .area_q strong{
        color: var(--main);
        transition: all .25s;
      }
    }

    .area{
      &_q{
        p, strong{
          font-size: 18px;
        }
      }
      &_a{
        padding: 21px 0 5px;
        font-size: 15px;
      }
    }


  }

  @media (max-width: 500px) {
    padding: 20px;

    .area{
      &_q{
        p, strong{
          font-size: 15px;
        }
        strong{
          font-family: 'Pretendard';
        }
      }
      &_a{
        padding-top: 20px;
        font-size: 13px;
      }
      
    }
  }
`